import React from 'react';
import GifCargando from './GifCargando';

const Cargando = ({height}) => {
    const h = height ? height : '300px';
    return (
        <div style={{ height: h, display:'flex', justifyContent:'center', alignItems: 'center' }}>
            <GifCargando height='35px' width='35px'/>
        </div>
    )
}

export default Cargando;